import classNames from "classnames";
import LargeEmptyStar from "static/images/LargeEmptyStar.svg";
import LargeFilledStar from "static/images/LargeFilledStar.svg";

export const StarRating = ({
  rating,
  onChange,
  readonly = false,
  totalStars = 5,
}: {
  rating: number;
  onChange?: (rating: number) => void;
  readonly?: boolean;
  totalStars?: number;
}) => {
  return (
    <div className="t-flex t-gap-0.5 t-items-center">
      {Array.from({ length: totalStars }, (_, index) => {
        const starNumber = index + 1;
        const isFilled = starNumber <= rating;

        return (
          <button
            key={starNumber}
            type="button"
            onClick={() => !readonly && onChange?.(starNumber)}
            disabled={readonly}
            className={classNames("all:unset t-select-none", {
              "t-cursor-default": readonly,
              "t-cursor-pointer": !readonly,
            })}
          >
            <img
              src={isFilled ? LargeFilledStar : LargeEmptyStar}
              alt="largeStar"
            />
          </button>
        );
      })}
    </div>
  );
};
